import { NavLink, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../App";
import {
  LayoutDashboard, ClipboardList, FileText, Wrench,
  Package, Users, UserCog, Truck, Receipt, BarChart3,
  Settings, LogOut, Car, Sun, Moon, Zap, ShieldCheck,
} from "lucide-react";
import { cn } from "../../lib/utils";

const NAV = [
  { to: "/dashboard",   label: "Dashboard",   icon: LayoutDashboard },
  { to: "/recepcion",   label: "Recepción",   icon: Car },
  { to: "/presupuestos",label: "Presupuestos", icon: FileText },
  { to: "/ordenes",     label: "Órdenes",      icon: Wrench },
  { to: "/repuestos",   label: "Repuestos",    icon: Package },
  { to: "/clientes",    label: "Clientes",     icon: Users },
  { to: "/tecnicos",    label: "Técnicos",     icon: UserCog },
  { to: "/proveedores",   label: "Proveedores",   icon: Truck },
  { to: "/aseguradoras",  label: "Aseguradoras",  icon: ShieldCheck },
  { to: "/facturacion",   label: "Facturación",   icon: Receipt },
  { to: "/sistema",     label: "Sistema",      icon: Settings },
];

const THEMES = [
  { value: "light", icon: Sun,  label: "Claro" },
  { value: "dark",  icon: Moon, label: "Oscuro" },
  { value: "ether", icon: Zap,  label: "Ether" },
];

const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, "");

export default function Sidebar({ onClose }) {
  const { user, logout, theme, setTheme, empresa, presupuestosReducidos } = useContext(AuthContext);
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/login");
    onClose?.();
  }

  return (
    <aside className="flex flex-col w-64 sm:w-56 shrink-0 border-r border-border bg-card h-full">
      {/* Logo */}
      <div className="flex items-center gap-2 px-4 py-4 border-b border-border">
        {empresa?.logo_url
          ? <img src={`${API_BASE}${empresa.logo_url}`} alt="Logo" className="h-7 w-auto object-contain shrink-0" />
          : <div className="w-7 h-7 rounded bg-primary flex items-center justify-center shrink-0">
              <Car className="w-4 h-4 text-primary-foreground" />
            </div>
        }
        <div className="leading-tight min-w-0">
          <p className="font-bold text-sm font-display truncate">{empresa?.nombre || "Taller del Este"}</p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-2 px-2 space-y-0.5">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            onClick={onClose}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors",
                isActive
                  ? "bg-primary text-primary-foreground font-medium"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              )
            }
          >
            <Icon className="w-4 h-4 shrink-0" />
            <span className="flex-1">{label}</span>
            {to === "/presupuestos" && presupuestosReducidos > 0 && (
              <span className="ml-auto min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-orange-500 text-white text-[10px] font-bold px-1">
                {presupuestosReducidos}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Tema + usuario */}
      <div className="border-t border-border p-3 space-y-2">
        {/* Selector de tema */}
        <div className="flex gap-1 p-1 bg-muted rounded-lg">
          {THEMES.map(({ value, icon: Icon, label }) => (
            <button
              key={value}
              title={label}
              onClick={() => setTheme(value)}
              className={cn(
                "flex-1 flex items-center justify-center py-1 rounded transition-colors",
                theme === value
                  ? "bg-background text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <Icon className="w-3.5 h-3.5" />
            </button>
          ))}
        </div>

        {/* Usuario */}
        <div className="flex items-center justify-between">
          <div className="min-w-0">
            <p className="text-xs font-medium truncate">{user?.nombre}</p>
            <p className="text-[10px] text-muted-foreground truncate">{user?.rol}</p>
          </div>
          <button
            onClick={handleLogout}
            title="Cerrar sesión"
            className="p-1.5 rounded hover:bg-destructive/10 hover:text-destructive text-muted-foreground transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </aside>
  );
}
